import DOMPurify from "dompurify";

export const decodeHtmlEntities = (str: string): string => {
  const textArea = document.createElement("textarea");
  textArea.innerHTML = str;
  return textArea.value;
};

// Function to create safe HTML markup
export const createMarkup = (htmlContent: string): { __html: string } => {
  const decodedHtml = decodeHtmlEntities(htmlContent);
  return { __html: DOMPurify.sanitize(decodedHtml) };
};
